import { render, staticRenderFns } from "./VanFieldAttachment.vue?vue&type=template&id=07e9e858"
import script from "./VanFieldAttachment.vue?vue&type=script&lang=js"
export * from "./VanFieldAttachment.vue?vue&type=script&lang=js"
import style0 from "./VanFieldAttachment.vue?vue&type=style&index=0&id=07e9e858&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports